/**
 * Entity export dataset keys. Must match backend exactly (GXM-1883).
 * Any other value will be rejected by the API.
 */
export const EXPORT_DATASET_KEYS = [
  "core_entity",
  "directors",
  "shareholders",
  "poa",
  "officers",
] as const;

export type ExportDatasetKey = (typeof EXPORT_DATASET_KEYS)[number];

/** Datasets that require Entity+ to be active on the entity. */
export const ENTITY_PLUS_GATED_DATASETS: readonly ExportDatasetKey[] = [
  "poa",
  "officers",
];

/** Map from backend key → UI display label (for summary view in modal). */
export const DATASET_LABELS: Record<ExportDatasetKey, string> = {
  core_entity: "Core Entity Information",
  directors: "Directors",
  shareholders: "Shareholders",
  poa: "Power of Attorney (PoAs)",
  officers: "Officers",
};

/** Type guard: checks if a string is a valid ExportDatasetKey. */
export function isExportDatasetKey(value: string): value is ExportDatasetKey {
  return (EXPORT_DATASET_KEYS as readonly string[]).includes(value);
}
